module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 78
// module chunks = 0